import React, { useEffect, useState } from 'react'
import List from './Components/List'
import Create from './Components/Create'
import { hasPermission, isAdmin } from '../../store/hooks/Permission';

export default function Enrollments() {
    const [canView, setCanView] = useState(false);

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
            } else {
                const viewAllowed = await hasPermission("EXAM", "Enrollments", "VIEW");
                setCanView(viewAllowed);
            }
        };
        checkPermissions();
    }, []);
    return (
        <>
            {!canView ? (
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="alert alert-danger">
                        You do not have permission to view this page.
                    </div>
                </div>
            ) : (
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row">
                        <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
                                    Back
                                </button>
                                <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / Enrollments</span> </small></p>
                            </div>
                            <div className="card">
                                {/* <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>Enrollments</h5>
                                <Create BTNLabel="Add New Enrollments" Header="Create Enrollments" Subheader="" PopupID="Enrollments" />
                            </div> */}
                                <div className="card-datatable table-responsive">
                                    <List />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
